import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import {
    Menu,
    MenuItem,
    Divider,
    ListItemIcon,
    ListItemText,
    IconButton
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const useStyles = makeStyles((theme) => styles(theme));

const propTypes = {
    setEditProject: PropTypes.func.isRequired,
    setDeleteProject: PropTypes.func.isRequired
};

const defaultProps = {

};

function ProjectMenu ({setEditProject, setDeleteProject}) {
    const classes = useStyles();
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    return (
        <>
            <IconButton
                classes={{ root: classes.menuButton }}
                size="small"
                onClick={(e) => setMenuAnchorEl(e.currentTarget)}
            >
                <MoreHorizIcon size="small" />
            </IconButton>
            <Menu
                open={Boolean(menuAnchorEl)}
                anchorEl={menuAnchorEl}
                onClose={() => setMenuAnchorEl(null)}
            >
                <MenuItem onClick={setEditProject}>
                    <ListItemIcon>
                        <EditIcon />
                    </ListItemIcon>
                    <ListItemText>
                        Edit
                    </ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem onClick={setDeleteProject}>
                    <ListItemIcon>
                        <DeleteIcon />
                    </ListItemIcon>
                    <ListItemText>
                        Delete
                    </ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
    
}

const styles = (theme) => ({
    menuButton: {
        position: 'absolute',
        top: 5,
        right: 5
    }
});

ProjectMenu.propTypes = propTypes;
ProjectMenu.defaultProps = defaultProps;

export default ProjectMenu;